/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

const listeners = new Set();
const pendingNotifications = [];

/**
 * Queues or broadcasts a global notification to any registered listeners.
 *
 * @param {{ message?: string, severity?: string, referenceId?: string }} notification - Notification payload to emit.
 */
export const emitGlobalNotification = (notification) => {
  if (!notification?.message) {
    return;
  }

  if (listeners.size === 0) {
    pendingNotifications.push(notification);
    return;
  }

  listeners.forEach((listener) => listener(notification));
};

/**
 * Registers a listener for global notifications and flushes any queued messages.
 *
 * @param {(notification: { message: string, severity?: string, referenceId?: string }) => void} listener - Callback invoked for each notification.
 * @returns {() => void} Unsubscribe function that removes the listener.
 */
export const subscribeToGlobalNotifications = (listener) => {
  listeners.add(listener);

  while (pendingNotifications.length > 0) {
    listener(pendingNotifications.shift());
  }

  return () => {
    listeners.delete(listener);
  };
};
